import styles from './ReceiptStatus.module.scss';

export const ReceiptStatusTitle = (props) => <div className={styles.title} {...props} />;
